<div class="inputs {{inputs_class}}"></div>
